module.exports = __webpack_public_path__ + "img/answer.8bcd6bbf.svg";